import { ArchiveBoxIcon, ArrowPathIcon, CubeTransparentIcon, ShieldCheckIcon } from '@heroicons/react/24/outline'
import AccountHero from './AccountHero'

const features = [
  { icon: ArchiveBoxIcon, title: 'Manual & scheduled', detail: 'Back up from your server' },
  { icon: ArrowPathIcon, title: 'Recovery options', detail: 'Restore verified backups' },
  { icon: ShieldCheckIcon, title: 'Backup protection', detail: 'Keep selected recovery points' },
]

export default function BackupVaultHero() {
  return <AccountHero label="Backup Vault" icon={CubeTransparentIcon} title={<>Your worlds, <span>ready to recover</span></>} subtitle="Recovery points from your active and deleted servers.">
    <div className="grid max-w-[650px] gap-4 sm:grid-cols-3">
      {features.map(({ icon: Icon, title, detail }) => <div key={title} className="flex items-center gap-3"><span className="rounded-full border border-violet-400/60 bg-violet-500/10 p-2.5"><Icon className="h-5 w-5 text-violet-400" /></span><div><p className="text-xs font-semibold">{title}</p><p className="mt-1 text-xs text-slate-400">{detail}</p></div></div>)}
    </div>
  </AccountHero>
}
